import React, { useContext, useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputAdornment from '@mui/material/InputAdornment'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Modal from '@mui/material/Modal'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import Stack from '@mui/material/Stack'
import Switch from '@mui/material/Switch'
import TextField from '@mui/material/TextField'
import Alert from '@mui/material/Alert'
import { TenantSettingsContext } from '../../../../App'

const AddShiftPopup = ({
  setPersonnel,
  open,
  onClose,
  addShift,
  selectedShift,
}) => {
  const [grade, setGrade] = useState('')
  const [rate, setRate] = useState(0)
  const [isHourly, setIsHourly] = useState(true)
  const [hours, setHours] = useState(0)
  const { orgConfig } = useContext(TenantSettingsContext)
  const payRates = orgConfig?.orgSettings?.defaultPayRates
  const roleOptions = orgConfig?.orgSettings?.roles ?? []
  const currency = orgConfig?.orgSettings?.currency ?? '£'
  const hourlyRateMissing = isHourly && !!grade && payRates?.[grade] == null

  useEffect(() => {
    if (selectedShift?.shift) {
      const shift = selectedShift.shift
      setGrade(shift?.grade)
      setRate(shift?.rate)
      setIsHourly(shift?.isHourly)
      setHours(shift?.hours)
    }
  }, [selectedShift])

  const submitAddShift = () => {
    if (selectedShift?.index >= 0) {
      setPersonnel((prev) =>
        prev.map((item, index) => {
          if (index === selectedShift.index) {
            return {
              ...item,
              grade,
              rate: !isHourly ? parseInt(rate) : (payRates?.[grade] ?? 0) * hours,
              isHourly,
              hours,
            }
          } else {
            return item
          }
        }),
      )
    } else {
      setPersonnel((prev) => [
        ...prev,
        {
          grade,
          rate: !isHourly ? parseInt(rate) : (payRates?.[grade] ?? 0) * hours,
          isHourly,
          hours,
        },
      ])
    }
    onClose()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      component="form"
      onSubmit={submitAddShift}
    >
      <Stack
        gap={2}
        component={Paper}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          padding: 2,
        }}
      >
        <FormControl size="small">
          <InputLabel id="grade-label">Grade</InputLabel>
          <Select
            value={grade}
            labelId="grade-label"
            label="Grade"
            required
            onChange={(e) => setGrade(e.target.value)}
          >
            {roleOptions.map((role, index) => (
              <MenuItem key={index} value={role}>
                {role}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Stack direction="row" gap={1}>
          {!isHourly ? (
            <TextField
              value={rate}
              type="number"
              onChange={(e) =>
                e.target.value >= 0 && setRate(parseFloat(e.target.value))
              }
              label="Rate"
              size="small"
              required={!isHourly}
              autoComplete="off"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">{currency}</InputAdornment>
                ),
              }}
            />
          ) : (
            <TextField
              value={hours}
              type="number"
              onChange={(e) =>
                e.target.value >= 0 && setHours(parseFloat(e.target.value))
              }
              label="Hours"
              inputProps={{
                step: '.01',
              }}
              size="small"
              required={isHourly}
              autoComplete="off"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">hrs</InputAdornment>
                ),
              }}
            />
          )}
          <Grid container alignItems="center" justifyContent="center">
            <Grid item>Fixed Rate</Grid>
            <Switch
              checked={isHourly}
              onChange={(e) => setIsHourly(e.target.checked)}
            />
            <Grid item>Hourly Rate</Grid>
          </Grid>
        </Stack>
        {hourlyRateMissing && (
          <Alert severity="warning">
            No hourly rate is configured for {grade}. Set one in Site
            Configuration → Shifts, or switch to Fixed Rate.
          </Alert>
        )}
        <Button
          fullWidth
          variant="contained"
          size="small"
          onClick={() => submitAddShift()}
          disabled={!grade || !hours || hourlyRateMissing}
        >
          Submit
        </Button>
      </Stack>
    </Modal>
  )
}

export default AddShiftPopup
